import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import getText from '../strings'
import styled from 'react-emotion'
import { ModalOverlay, ModalDialog } from '../../styles'

const Buttons = styled('div')`
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  button:first-child {
    width: 100%;
    margin-right: 10px;
  }
  button:last-child {
    width: 100%;
    margin-left: 10px;
  }
`

const portalRoot = document.getElementById('customer-mytui-web-portal-root')

export default class Confirm extends Component {
  state = { open: false }
  componentDidMount() {
    this.modal = document.createElement('div')
  }
  componentWillUnmount() {
    this.close()
  }
  open = () => {
    portalRoot.appendChild(this.modal)
    document.body.classList.add('x-tui-modal')
    this.setState({ open: true })
  }
  close = result => {
    if (portalRoot.contains(this.modal))
      portalRoot.removeChild(this.modal)
    document.body.classList.remove('x-tui-modal')
    this.props.onResult(result)
    this.setState({ open: false })
  }
  render() {
    const { question, Opener } = this.props
    const { open } = this.state

    const portal = open && ReactDOM.createPortal(
      <ModalOverlay>
        <ModalDialog width={400}>
          <h3>{question}</h3>
          <Buttons>
            <button onClick={() => this.close(true)} className="btn btn-function">{getText('yes')}</button>
            <button onClick={() => this.close(false)} className="btn ghost-blue">{getText('no')}</button>
          </Buttons>
        </ModalDialog>
      </ModalOverlay>,
      this.modal
    )

    return (
      <Fragment>
        {portal}
        <span onClick={this.open}>
          <Opener />
        </span>
      </Fragment>
    )
  }
}